import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CoursesSection from './components/CoursesSection';
import ProfessorsSection from './components/ProfessorsSection';
import GallerySection from './components/GallerySection';
import SocialSection from './components/SocialSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App bg-black text-white overflow-x-hidden">
      <Navbar />
      <section id="home">
        <HeroSection />
      </section>
      <section id="about">
        <AboutSection />
      </section>
      <section id="courses">
        <CoursesSection />
      </section>
      <section id="professors">
        <ProfessorsSection />
      </section>
      <section id="gallery">
        <GallerySection />
      </section>
      {/* <section id="testimonials">
        <TestimonialsSection />
      </section> */}
      <section id="contact">
        <SocialSection />
      </section>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
